import React, { ChangeEvent, useMemo } from "react";

import {
  createDefaultYearsArray,
  createYearsArrayForAgeLimit,
  createYearsArrayForMedCardExpiration,
} from "utils/yearSelectUtils";

import Select from "components/botanic/Select";
import Option from "components/Option";

export type ArrayType = "ageLimit" | "medCardExpiration";

const YearSelect: React.FC<{
  countryCode?: string;
  defaultValue: number;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  selectedDay?: number;
  selectedMonth?: number;
  state?: string;
  arrayType?: ArrayType;
  id: string;
}> = ({
  defaultValue,
  onChange,
  arrayType,
  countryCode,
  id,
  selectedDay,
  selectedMonth,
  state,
}) => {
  const years: number[] = useMemo(() => {
    if (arrayType === "medCardExpiration") {
      return createYearsArrayForMedCardExpiration({
        selectedDay,
        selectedMonth,
      });
    } else if (arrayType === "ageLimit" && countryCode) {
      return createYearsArrayForAgeLimit({
        countryCode: countryCode as string,
        selectedDay,
        selectedMonth,
        state,
      });
    } else {
      return createDefaultYearsArray();
    }
  }, [arrayType, countryCode, selectedDay, selectedMonth, state]);

  const dropDownDisabled =
    arrayType === "medCardExpiration" &&
    selectedMonth === 0 &&
    selectedDay === 0;

  return (
    <Select
      disabled={dropDownDisabled}
      id={`${id}-year-select`}
      label="Year"
      defaultValue={defaultValue}
      onChange={onChange}
    >
      <Option value=""></Option>
      {years.map((year) => (
        <Option disabled={dropDownDisabled} value={year} key={year}>
          {year}
        </Option>
      ))}
    </Select>
  );
};

export default YearSelect;
